export default __webpack_public_path__ + "static/media/preloader.28265a53.gif";